var chunkMapping = {
	"636": [
		4832,
		9122,
		4249,
		3933
	],
	"1471": [
		1471
	],
	"2643": [
		2643
	],
	"3013": [
		3013
	],
	"3897": [
		3897
	],
	"4526": [
		4526
	],
	"4719": [
		4719
	],
	"4911": [
		4911
	],
	"5135": [
		5135
	],
	"5532": [
		5532
	],
	"5644": [
		5644
	],
	"5656": [
		5656
	],
	"5682": [
		5682
	],
	"7339": [
		7339
	],
	"8338": [
		8338
	],
	"8388": [
		8388
	],
	"8491": [
		8491
	],
	"8783": [
		8783
	],
	"9415": [
		9415
	]
};
var idToExternalAndNameMapping = {
	"1471": [
		"default",
		"./list",
		5001
	],
	"2643": [
		"default",
		"./details",
		5001
	],
	"3013": [
		"default",
		"./details/nutrition-advisor",
		5001
	],
	"3897": [
		"default",
		"./details/edit/frequency",
		5001
	],
	"3933": [
		"default",
		"./version",
		8716
	],
	"4249": [
		"default",
		"./version",
		5001
	],
	"4526": [
		"default",
		"./details/confirm-plan",
		5001
	],
	"4719": [
		"default",
		"./details/edit/addresses",
		5001
	],
	"4832": [
		"default",
		"./version",
		8927
	],
	"4911": [
		"default",
		"./checkoutPage",
		3722
	],
	"5135": [
		"default",
		"./details/nutrition-advisor/appointment",
		5001
	],
	"5532": [
		"default",
		"./edit-date",
		5001
	],
	"5644": [
		"default",
		"./checkoutConfirmationPage",
		3722
	],
	"5656": [
		"default",
		"./details/edit/payment-methods",
		5001
	],
	"5682": [
		"default",
		"./details/edit",
		5001
	],
	"7339": [
		"default",
		"./list",
		8716
	],
	"8338": [
		"default",
		"./details/services",
		5001
	],
	"8388": [
		"default",
		"./cartPanelToggle",
		8927
	],
	"8491": [
		"default",
		"./cartPage",
		8927
	],
	"8783": [
		"default",
		"./details/nutrition-advisor/schedule",
		5001
	],
	"9122": [
		"default",
		"./version",
		3722
	],
	"9415": [
		"default",
		"./details",
		8716
	]
};
var idToRemoteMap = {
	"1471": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"2643": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"3013": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"3897": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"3933": [
		{
			"externalType": "script",
			"name": "ordersMFE",
			"externalModuleId": 8716
		}
	],
	"4249": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"4526": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"4719": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"4832": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 8927
		}
	],
	"4911": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 3722
		}
	],
	"5135": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"5532": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"5644": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 3722
		}
	],
	"5656": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"5682": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"7339": [
		{
			"externalType": "script",
			"name": "ordersMFE",
			"externalModuleId": 8716
		}
	],
	"8338": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"8388": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 8927
		}
	],
	"8491": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 8927
		}
	],
	"8783": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 5001
		}
	],
	"9122": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 3722
		}
	],
	"9415": [
		{
			"externalType": "script",
			"name": "ordersMFE",
			"externalModuleId": 8716
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}